export default {
      id: "alu-usage",
      viewBox: "0 0 2100 100",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#alu-usage",
      toString: function () {
        return this.url;
      }
    }